<template>
    <main class="NotFound">
        <div class="NotFound_box">
            <h1>404</h1>
            <router-link to="/" class="link">Back to home</router-link>
        </div>
    </main>
</template>

<script>
import { RouterLink } from 'vue-router';


    export default {
        name: "NotFound",
        data() {
            return {
            // 
            };
        },
        components: { RouterLink }
    }
</script>

<style lang="scss" scoped>
    @import '~@/scss/colors.scss';
    .NotFound {
        display: grid;
        place-items: center;
        width: 100%;
        height: auto;
        min-height: 100vh;
        text-align: center;
        h1{
            font-size: 100px;
            color: $purple;
            display: block;
            margin: 0;
            font-weight: 300;
            line-height: 1.1;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue